import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Hero/hero";
import travelImg from "../assets/images/banners/3.png";
import Footer from "../components/Footer/Footer";
import Packages from "../components/Packages/Packages";

function PackagesPage() {
    return (
        <>
            <Navbar />
            <Hero
                cName="hero-mid"
                heroImg={travelImg}
                title=""
                btnClass="hide"
            />
            <Packages />
            <Footer />
        </>
    );
}

export default PackagesPage;
